import { useRef, useState } from "react";

interface UseClearFiltersModalProps {
  activeFiltersCount: number;
  clearAllFilters: () => void;
}

export function useClearFiltersModal({
  clearAllFilters,
  activeFiltersCount,
}: UseClearFiltersModalProps) {
  const filterButtonRef = useRef<HTMLButtonElement>(null);
  const [showFilters, setShowFilters] = useState<boolean>(() => activeFiltersCount > 0);
  const [showFiltersModal, setShowFiltersModal] = useState<boolean>(false);

  const handleToggleFilters = () => {
    if (!showFilters) {
      setShowFilters(true);
    } else {
      if (activeFiltersCount > 0) setShowFiltersModal(true);
      else setShowFilters(false);
    }
  };

  const handleClearFilters = () => {
    clearAllFilters();
    setShowFilters(false);
    setShowFiltersModal(false);
  };

  return {
    filterButtonRef,
    showFilters,
    setShowFilters,
    showFiltersModal,
    setShowFiltersModal,
    handleToggleFilters,
    handleClearFilters,
  };
}
